import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Reaptcha from 'reaptcha';

import {
  reset,
} from 'redux-form';

import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';

import InquiryForm from './components/InquiryForm';

import {
  createInquiry,
  getCountriesList,
} from '@actions/inquiry';

import {
  getCountries,
} from '@selectors/inquiry';

import './Inquiry.scss';

const RECAPTCHA_SITEKEY = process.env.REACT_APP_RECAPTCHA_SITEKEY;

class Inquiry extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSuccessNotificationOpen: false,
      isErrorNotificationOpen: false,
      isSubmitting: false,
    };

    this.setInquiryValues = this.setInquiryValues.bind(this);
    this.closeSuccessNotification = this.closeSuccessNotification.bind(this);
    this.closeErrorNotification = this.closeErrorNotification.bind(this);
    this.executeCaptcha = this.executeCaptcha.bind(this);
  }

  componentDidMount() {
    const { match: { params: { id } } } = this.props;
    this.props.fetchCountriesList(id);
  }

  setInquiryValues(values) {
    const { match: { params: { id } } } = this.props;
    this.setState({
      isSubmitting: true,
    });
    return token => (
      this.props.submitInquiry(id, {
        ...values,
        recaptchaToken: token,
      }).then(() => {
        this.setState({
          isSuccessNotificationOpen: true,
          isSubmitting: false,
        });
        this.props.resetInquryForm();
      }).catch(() => {
        this.setState({
          isErrorNotificationOpen: true,
          isSubmitting: false,
        });
      })
    );
  }

  executeCaptcha(values) {
    this.submitInquiry = this.setInquiryValues(values);
    this.recaptchaInstance.reset();
    this.recaptchaInstance.execute();
  }

  closeSuccessNotification() {
    this.setState({
      isSuccessNotificationOpen: false,
    });
  }

  closeErrorNotification() {
    this.setState({
      isErrorNotificationOpen: false,
    });
  }

  render() {
    const { countries } = this.props;
    const { isSubmitting } = this.state;
    return (
      <Paper className="inquiry">
        <p className="inquiry__title">
          Submit an Inquiry
        </p>
        <InquiryForm
          countries={countries}
          onSubmit={this.executeCaptcha}
          initialValues={{
            address: {
              country: 1,
            },
          }}
          isSubmitting={isSubmitting}
        />
        <Reaptcha
          ref={(ref) => { this.recaptchaInstance = ref; }}
          sitekey={RECAPTCHA_SITEKEY}
          size="invisible"
          onVerify={(token) => {
            this.submitInquiry(token);
          }}
        />
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open={this.state.isSuccessNotificationOpen}
          onClose={this.closeSuccessNotification}
          autoHideDuration={5000}
          message="Your inquiry has been submitted. Thank you."
          ContentProps={{
            style: {
              backgroundColor: '#7ac143',
            },
          }}
        />
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open={this.state.isErrorNotificationOpen}
          onClose={this.closeErrorNotification}
          autoHideDuration={5000}
          message="Something went wrong."
          ContentProps={{
            style: {
              backgroundColor: '#ff4e00',
            },
          }}
        />
      </Paper>
    );
  }
}

Inquiry.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fetchCountriesList: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  resetInquryForm: PropTypes.func.isRequired,
  submitInquiry: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  countries: getCountries(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchCountriesList: getCountriesList,
  submitInquiry: createInquiry,
  resetInquryForm: () => reset('inquiry'),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Inquiry);



// WEBPACK FOOTER //
// ./src/routes/Case/Inquiry/Inquiry.js